// extracted by mini-css-extract-plugin
module.exports = {"root":"dh-forklaringsscroll-root"};